<template>
  <div class="bk-main-canvas relative">
    <ClientOnly>
      <div v-if="drupalUser.accessToolbar && !isEditing"
        class="hidden border-b border-b-gray-100 bg-white lg:block admin-block">
        <VuepalAdminToolbar :key="language" />
        <div class="etx-container Container pt-50 pb-0">
          <div class="etx-center Center">
            <VuepalLocalTasks />
          </div>
        </div>
      </div>
    </ClientOnly>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const drupalUser = useDrupalUser()
const language = useCurrentLanguage()

import { onMounted } from 'vue';

const isEditing = computed(
  () =>
    !!(route.query.blokkliEditing || route.query.blokkliPreview) &&
    drupalUser.value.accessToolbar,
)

useHead({
  htmlAttrs: {
    lang: language.value,
  },
})

onMounted(() => {

  if (typeof initEmptyClick === 'function') {
    initEmptyClick();
  }

  if (typeof initHeader === 'function') {
    initHeader();
  }

  if (typeof initScrolldown === 'function') {
    initScrolldown();
  }

  if (typeof initTables === 'function') {
    initTables();
  }

  if (typeof initSwipers === 'function') {
    initSwipers();
  }

  if (typeof initTabs === 'function') {
    initTabs();
  }

  if (typeof etxLazyLoad === 'function') {
    etxLazyLoad();
  }

  if (typeof etxInViewport === 'function') {
    etxInViewport();
  }

  if (typeof etxAccordion === 'function') {
    etxAccordion();
  }

  if (typeof setSwiperImagesHeight === 'function') {
    setSwiperImagesHeight();
  }

  if (typeof initBigPicture === 'function') {
    initBigPicture();
  }

});

</script>

<style lang="postcss" scoped>
.home .admin-block {
  background-color: var(--color-secondary-100);
}
</style>